import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Tables from "layouts/tables";
import { useState } from "react";
import { useGetStaffQuery, useDeleteStaffMutation } from "slices/staffSlice";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function Staff() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [del] = useDeleteStaffMutation();

  const { data, isLoading, error, refetch } = useGetStaffQuery({
    page,
    limit,
    search,
  });
  const col = [
    { display: "Name", key: "name", type: "display" },
    { display: "Email", key: "email", type: "display" },
    { display: "Role", key: "role", type: "display" },
    {
      display: "Actions",
      key: "edit",
      type: "action",
      render: (row, onEdit, handleDelete) => (
        <>
          <Button onClick={() => onEdit(row)}>Edit</Button>
          <Button onClick={() => handleDelete(row._id)}>Delete</Button>
        </>
      ),
    },
  ];
  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(1);
  };
  const changePage = (newPage, newLimit) => {
    const apiPage = newPage + 1; // MUI is 0-based, API is 1-based
    setPage(apiPage);
    setLimit(newLimit);
  };

  const handleAdd = () => {
    navigate("/staff/add-staff");
  };

  const onEdit = (row) => {
    navigate(`/staff/update-staff/${row._id}`);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this staff?")) {
      await del(id).unwrap();
      refetch();
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Button onClick={handleAdd} style={{ background: "#fff" }}>
        Add Staff
      </Button>
      <Tables
        title={"Staff"}
        handleSearch={handleSearchChange}
        totalPages={data?.page}
        data={data?.data}
        columns={col}
        changePage={changePage}
        onEdit={onEdit}
        handleDelete={handleDelete}
        currentPage={page} // ✅ pass to control current pagination
        rowsPerPage={limit}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Staff;
